/* ============
 * Product Packaging Transformer
 * ============
 *
 * The transformer for the product packaging.
 */

import Transformer from './transformer';

export default class ProductPackagingTransformer extends Transformer {

  static fetch(productPackaging) {
    return {
      id: productPackaging.id,
      name: productPackaging.name,
      volume: productPackaging.volume,
      qtyInCrate: productPackaging.qty_in_crate,
      packagingTypeId: productPackaging.packaging_type_id,
      packagingMaterialId: productPackaging.packaging_material_id,
      materialId: productPackaging.material_id,
      crateMaterialId: productPackaging.crate_material_id,
      productDepositId: productPackaging.product_deposit_id,
      depositSystemId: productPackaging.deposit_system_id,
      exciseBasicGroup: productPackaging.excise_basic_group,
      excisePackagingGroup: productPackaging.excise_packaging_group,
      overrideProducts: productPackaging.override_products,
      productsCount: productPackaging.products_count,
    };
  }

  static send(productPackaging) {
    return {
      id: productPackaging.id,
      name: productPackaging.name,
      volume: productPackaging.volume,
      qty_in_crate: productPackaging.qtyInCrate,
      packaging_type_id: productPackaging.packagingTypeId,
      packaging_material_id: productPackaging.packagingMaterialId,
      material_id: productPackaging.materialId ? productPackaging.materialId : null,
      crate_material_id: productPackaging.crateMaterialId ? productPackaging.crateMaterialId : null,
      excise_basic_group: productPackaging.exciseBasicGroup ? productPackaging.exciseBasicGroup : null,
      excise_packaging_group: productPackaging.excisePackagingGroup ? productPackaging.excisePackagingGroup : null,
      deposit_system_id: productPackaging.depositSystemId ? productPackaging.depositSystemId : null,
      product_deposit_id: productPackaging.productDepositId ? productPackaging.productDepositId : null,
      override_products: productPackaging.overrideProducts,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/productPackaging.js